















































































































/* eslint-disable */
import { Component, Vue, Emit } from 'vue-property-decorator'
import { Apis, Factories, Services } from '@finx/web-repository'
import { Provisao, ProcedimentoProvisao } from '@finx/web-repository/src/types/Provisao'
import Procedimentos from '@finx/web-repository/src/apis/Backoffice/services/Procedimentos'
import Animations from '@/factories/Animations'
import { ProvisaoDadosProcedimento } from '@/types/_'
import ProvisaoStore from '@/store/Provisao'

@Component

export default class ComponentProvisaoFooter extends Vue {
  alert = {
    show: false,
    error: false,
    buttons: [
      {
        text: 'Provisão salva!',
        action: '/provisao',
        color: 'primary',
      },
    ],
    icon: '',
    iconColor: '',
    subtitle: '',
    title: '',
  }

  snackbar: any = {
    disabled: false,
    message: '',
    show: false,
    timeout: 3000,
  }

  steps: any = [
    {
      name: 'Dados iniciais',
      completed: true,
      disabled: false,
      color: 'DADOS_INICIAIS_STATUS_COLOR',
      orderIcon: 'looks_one',
      opens: 'showProvisaoDadosIniciais',

    },
    {
      name: 'Informações adicionais',
      completed: true,
      color: 'INFORMACOES_ADICIONAIS_STATUS_COLOR',
      orderIcon: 'looks_two',
      opens: 'showProvisaoInformacoesAdicionais',
      namePropertyEnable: 'BLOQUEAR_INFORMACOES_ADICIONAIS',
    },
    {
      name: 'Função',
      completed: true,
      color: 'FUNCOES_STATUS_COLOR',
      orderIcon: 'looks_3',
      opens: 'showProvisaoFuncao',
      namePropertyEnable: 'BLOQUEAR_FUNCOES_PROCEDIMENTOS',
    },
  ]

  showModalAddProcedimentos: Boolean = false
  loadingProcedimentosList: Boolean = true
  loading: any = {
    status: false,
    text: 'Calculando...',
  }

  procedimentos: any[] = []

  user: any = {}

  get getDadosIniciaisStatusColor() {
    return ProvisaoStore.getters.DADOS_INICIAIS_STATUS_COLOR
  }

  get enableSave() {
    return this.getFontePagadoraId !== ''
      && this.getLocalExecucaoSelected !== ''
      && this.getNomePaciente !== ''
      && this.getDataProcedimento !== ''
      && this.getProcedimentos.length > 0
      && this.isQuantidadeValido
      && this.provisaoValido
      && this.isProfissionalExecutanteAtivo
      && this.isAplicaViaAcesso
  }

  get provisaoValido() {
    return ProvisaoStore.getters.PROVISAO_VALIDO
  }

  get perfilProfissionalExecutante() {
    return ProvisaoStore.getters.PERFIL_PROFISSIONAL_EXECUTANTE
  }

  get getBloquearFuncoesProcedimentos() {
    return ProvisaoStore.getters.BLOQUEAR_FUNCOES_PROCEDIMENTOS
  }

  get getBloquearResumoProcedimentos() {
    return ProvisaoStore.getters.BLOQUEAR_RESUMO_PROCEDIMENTOS
  }

  get getBloquearInformacoesAdicionais() {
    return ProvisaoStore.getters.BLOQUEAR_INFORMACOES_ADICIONAIS
  }

  get getters() {
    return ProvisaoStore.getters
  }

  get provisao() {
    return ProvisaoStore.getters.PROVISAO
  }

  get showProvisaoDadosIniciais(): Boolean {
    return this.provisao.DIALOG_DADOS_INICIAIS
  }

  set showProvisaoDadosIniciais(newValue) {
    ProvisaoStore.commit('SET_DIALOG_DADOS_INICIAIS', newValue)
  }

  get showProvisaoFuncao(): Boolean {
    return this.provisao.DIALOG_FUNCAO
  }

  set showProvisaoFuncao(newValue) {
    ProvisaoStore.commit('DIALOG_FUNCAO', newValue)
  }

  get showProvisaoInformacoesAdicionais(): Boolean {
    return this.provisao.DIALOG_INFORMACOES_ADICIONAIS
  }

  set showProvisaoInformacoesAdicionais(newValue) {
    this.provisao.aplicarTipoAtendimento = this.isTipoAtendimento
    this.provisao.aplicarAcomodacao = this.isTipoAcomodacao

    ProvisaoStore.commit('DIALOG_INFORMACOES_ADICIONAIS', newValue)
  }

  get showProvisaoResumo(): Boolean {
    return ProvisaoStore.getters.DIALOG_RESUMO
  }

  set showProvisaoResumo(newValue) {
    ProvisaoStore.commit('DIALOG_RESUMO', newValue)
  }

  get isTipoAtendimento() {
    const p = this.getProcedimentos
    return !p.some(c => c.aplicaUrgencia === true)
  }

  get isTipoAcomodacao() {
    const u = this.getProcedimentos
    return !u.some(c => c.aplicaAcomodacao === true)
  }

  get getProcedimentos(): ProvisaoDadosProcedimento[] {
    return ProvisaoStore.getters.PROCEDIMENTOS
  }

  async modalAddProcedimentosSelected(selected) {
    this.scrollToBottom()

    const newProcedimento = { ...selected,
      quantidade: 0,
      viaAcesso: 0,
      sequencial: selected.sequencial }

    if (this.getProcedimentos.length === 0) {
      newProcedimento.quantidade = 1
      newProcedimento.viaAcesso = 1
    }

    ProvisaoStore.dispatch('SET_PROCEDIMENTO_SELECTED', newProcedimento)
    ProvisaoStore.dispatch('HABILITAR_ENVIO_PROVISAO')
    ProvisaoStore.dispatch('SET_BLOQUEAR_INFORMACOES_ADICIONAIS', false)
  }

  get contatoId() {
    return ProvisaoStore.getters.CONTRATO_ID
  }

  get funcao() {
    return ProvisaoStore.getters.FUNCAO
  }

  get stateProvisao() {
    return ProvisaoStore.getters.STATE_PROVISAO
  }

  get getFontePagadoraId() {
    return ProvisaoStore.getters.FONTE_PAGADORA_ID
  }

  get getLocalExecucaoSelected() {
    return ProvisaoStore.getters.LOCAL_EXECUCAO_SELECTED
  }

  get getNomePaciente() {
    return ProvisaoStore.getters.NOME_PACIENTE
  }

  get isQuantidadeValido() {
    return !this.getProcedimentos.some(p => p.quantidade === undefined || p.quantidade === 0)
  }

  get isAplicaViaAcesso() {
    let valid = false
    this.getProcedimentos.map((p) => {
      if (!valid && p.aplicaViaAcesso && p.viaAcesso === 0) {
        valid = true
      }
    })

    return !valid
  }

  get enableViaAcesso() {
    return this.getProcedimentos.some(p => p.aplicaViaAcesso)
  }

  get profissionaisExecutantes() {
    return ProvisaoStore.getters.PROFISSIONAIS_EXECUTANTES
  }

  get isProfissionalExecutanteAtivo() {
    return this.profissionaisExecutantes.some(p => p.status === false)
  }

  get getDataProcedimento() {
    return ProvisaoStore.getters.DATA_PROCEDIMENTO
  }

  get contratoGrupoRemuneracao() {
    return ProvisaoStore.getters.CONTRATO_GRUPO_REMUNERACAO
  }

  get localExecucao() {
    return ProvisaoStore.getters.LOCAL_EXECUCAO_ID
  }

  get operadora() {
    return ProvisaoStore.getters.OPERADORA_ID
  }

  get planoOperadora() {
    return ProvisaoStore.getters.PLANO_OPERADORA_ID
  }

  get provisaoValorTotal() {
    return ProvisaoStore.getters.PROVISAO_VALOR_TOTAL
  }

  get calculadora() {
    return ProvisaoStore.getters.CALCULADORA
  }

  get isEnableBotaoProcedimento() {
    return (this.contratoGrupoRemuneracao !== '' && this.contatoId !== '' && this.localExecucao !== '' && this.getNomePaciente !== '' && this.getDataProcedimento !== '')
  }

  actionAlertButton() {
    this.$router.push('/producao')
  }

  async getProcedimentosInit() {
    this.showModalAddProcedimentos = true
    this.loadingProcedimentosList = true
    const request = await Apis.Contratos.Procedimentos
      .getProcedimentosByContrato(this.provisao.contratoId,
        this.contratoGrupoRemuneracao,
        this.localExecucao,
        this.operadora !== undefined && this.operadora !== null ? this.operadora : '',
        this.planoOperadora !== undefined && this.planoOperadora !== null ? this.planoOperadora : '')

    const success = Factories.Apis.success(request)

    if (success) {
      this.procedimentos = request.data
      this.loadingProcedimentosList = false
    }
  }

  async saveProvisao() {
    this.loading.text = 'Salvando o procedimento'
    this.loading.status = true
    ProvisaoStore.dispatch('SET_PROVISAO_VALIDO', false)
    const p: Provisao = {
      identificador: this.$route.params.producaoid,
      contratoId: this.contatoId,
      acomodacao: this.getProcedimentos.some(c => c.aplicaAcomodacao === true)
        ? this.provisao.informacoesAdicionais.tipoAcomodacao : null,
      urgente: this.getProcedimentos.some(c => c.aplicaUrgencia === true)
        ? this.provisao.informacoesAdicionais.tipoAtendimento : null,
      nomePaciente: this.provisao.dadosIniciais.nomePaciente,
      dataRealizacao: this.provisao.dadosIniciais.dataProcedimento,
      prestadorId: this.provisao.dadosIniciais.prestadorId,
      planoOperadoraNome: this.provisao.dadosIniciais.operadoraSelected.planoOperadora,
      planoOperadoraId: this.provisao.dadosIniciais.operadoraSelected.planoOperadoraId,
      fontePagadoraId: this.provisao.dadosIniciais.fontePagadoraId,
      localExecucaoId: this.provisao.dadosIniciais.localExecucaoSelected.localExecucaoId,
      operadoraId: this.provisao.dadosIniciais.operadoraSelected.operadoraId,
      profissionaisExecutantes: this.funcao
        .profissionaisExecutantes
        .reduce((target, source) => {
          if (source.status === false) {
            target.push({
              id: source.id,
              funcao: source.funcao,
            })
          }
          return target
        }, []),
      procedimento: [],
    }

    this.getProcedimentos.map((source) => {
      p.procedimento.push({
        contratoProcedimentoId: source.id,
        codigo: source.codigo,
        acomodacao: !this.isTipoAcomodacao
          ? this.provisao.informacoesAdicionais.tipoAcomodacao : null,
        descricao: source.descricao,
        quantidade: source.quantidade,
        sequencial: source.sequencial,
        urgente: !this.isTipoAtendimento
          ? this.provisao.informacoesAdicionais.tipoAtendimento : null,
        viaAcesso: this.enableViaAcesso ? source.viaAcesso : null,
        invasivo: true,
        previsaoRecebimento: '2020-04-15T15:00:00',
        prazoRecebimento: 2,
        quantidadeAuxiliarPermitido: source.quantidadeAuxiliarPermitido,
      })
      return source
    })

    let success: Boolean = false

    if (this.$route.params.action !== 'editar') {
      this.$ga.event('producao', 'adicionar', this.user.email)

      const request = await Apis.Legacy.Producao.saveProducaoV2(p)
      this.snackbar.message = Factories.ErrorMessage(request)
      success = Factories.Apis.success(request)
    } else {
      this.$ga.event('producao', 'editar', this.user.email)

      const request = await Apis.Legacy.Producao.updateProducao(p)
      success = Factories.Apis.success(request)
      this.snackbar.message = Factories.ErrorMessage(request)
    }

    this.loading.status = false

    if (success) {
      this.alert.show = true
    } else {
      this.snackbar.show = true
    }

    ProvisaoStore.dispatch('SET_DATA_PROCEDIMENTO', new Date().toISOString().substr(0, 10))
    ProvisaoStore.dispatch('SET_PROVISAO_VALIDO', true)
  }

  mounted() {
    this.getUser()
  }

  getEnabled(step) {
    return step.disabled
  }

  getButtonColor(step) {
    if (step.warning) {
      return 'warning'
    }
    if (step.completed) {
      return 'success'
    }
    if (!step.disabled) {
      return 'secondary'
    }
    return 'primary'
  }

  getButtonIcon(step) {
    if (ProvisaoStore.getters[step.color] === 'success') {
      return 'check_box'
    }

    return 'check_box_outline_blank'
  }

  async getUser() {
    this.user = this.$user.profile
  }

  openDialog(dialog) {
    this[dialog] = true
  }

  scrollToBottom() {
    Animations.smothScroll('#provisao-scroll')
  }
}
